import React from 'react';
import { Layout, Content, ContentBody } from './layout';
import SideBar from '../../components/commoncomponents/SideBar';
import Header from '../../components/commoncomponents/Header';
import Footer from '../../components/commoncomponents/Footer';
import { Outlet } from 'react-router-dom';
import Vendorsidebar from '../../components/commoncomponents/Vendorsidebar';
import Userdeptsidebar from '../../components/commoncomponents/Userdeptsidebar';

const MainLayout = () => {
  const roleName = localStorage.getItem('roleName')?.trim();  // Fetch roleName once and trim spaces

  return (
    <Layout component={'section'}>
      {/* Check for vendor or department user and render the correct sidebar */}
      {roleName === "Vendors" ? (
        <Vendorsidebar />
      ) : roleName === "DeptUser" ? (
        <Userdeptsidebar />
      ) : (
        <SideBar />
      )}

      <Content component={'section'}>
        <Header />
        <ContentBody component={'main'}>
          <Outlet />
        </ContentBody>
        <Footer />
      </Content>
    </Layout>
  );
};

export default MainLayout;

